import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Card from "../../../components/Card";
import { Row, Col, Image } from "react-bootstrap";
import {
  acceptCreatorFrom,
  getCreatorForms,
  rejectCreatorFrom,
} from "../../../helpers/opportunity";
import { RxCross1 } from "react-icons/rx";
import { SiNike } from "react-icons/si";
import { toast } from "react-hot-toast";

const CreatorForm = () => {
  const [forms, setForms] = useState();
  async function getCreatorFormsData() {
    const res = await getCreatorForms();
    if (res.message === "Forms fetched succesfully") {
      setForms(res.forms);
    }
  }
  console.log(forms, "forms");
  async function acceptCreatorFormHandler(form) {
    let body = {
      email: form?.email,
      key: "pushparaj",
    };
    console.log(body, "body");
    const res = await acceptCreatorFrom(body, form._id);
    console.log(res, "res accept");
    if (res.createdcreator) {
      getCreatorFormsData();
    } else if (res.error) {
      toast.error(res.error);
    }
  }

  async function rejectCreatorFromHandler(form) {
    let body = {
      email: form?.email,
      key: "pushparaj",
    };
    const res = await rejectCreatorFrom(body, form._id);

    if (res.response === "Successfully rejected creator") {
      getCreatorFormsData();
    }
  }

  useEffect(() => {
    getCreatorFormsData();
  }, []);

  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">Opportunity List</h4>
                </div>
              </Card.Header>
              <Card.Body className="px-0">
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        {/* <th>Profile</th> */}
                        <th>Creator Name</th>
                        <th>Email</th>
                        <th>Location</th>

                        <th>Status</th>
                        <th>Social</th>
                        <th>Change Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {forms && forms.length === 0 && <div>No Forms Found</div>}
                      {forms &&
                        forms.map((form, index) => {
                          return (
                            <tr key={index}>
                              <td
                                style={{
                                  //   textAlign: "center",
                                  padding: "15px",
                                }}
                              >
                                {form?.name}
                              </td>
                              <td
                                style={{
                                  //   textAlign: "center",
                                  padding: "15px",
                                }}
                              >
                                {form?.email}
                              </td>
                              <td
                                style={{
                                  //   textAlign: "center",
                                  padding: "15px",
                                }}
                              >
                                {form?.location}
                              </td>
                              {/* <td
                                style={{
                                  //   textAlign: "center",
                                  padding: "15px",
                                }}
                              >
                                {form?.status}
                              </td> */}

                              <td style={{ padding: "15px" }}>
                                <span
                                  className={`badge ${
                                    form?.status === "accepted"
                                      ? "bg-success"
                                      : form?.status === "rejected"
                                      ? "bg-danger"
                                      : "bg-secondary"
                                  }`}
                                >
                                  {form?.status}
                                </span>
                              </td>

                              <Link to={form?.social}>
                                <td
                                  style={{
                                    //   textAlign: "center",
                                    padding: "15px",
                                  }}
                                >
                                  {form?.social}
                                </td>
                              </Link>
                              <td
                                style={{
                                  textAlign: "center",
                                  padding: "15px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <RxCross1
                                    style={{ color: "red", cursor: "pointer" }}
                                    onClick={() =>
                                      rejectCreatorFromHandler(form)
                                    }
                                  />
                                  <SiNike
                                    style={{
                                      color: "green",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      acceptCreatorFormHandler(form)
                                    }
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CreatorForm;
